import { wrapProtectedRoute } from 'components/desktop/_general/ProtectedRoute/ProtectedRoute';
import Detail from 'containers/desktop/Accessory/Detail/AccessoryDetail';
import New from 'containers/desktop/Accessory/New/AccessoryNew';
import Search from 'containers/desktop/Accessory/Search/AccessorySearch';
import PERMISSIONS from 'enums/permissions';

const basicResources = ['tagList', 'unitList'];

const sharedSearchResources = ['co2Labels', 'accessoryCategories', 'tagList'];

const searchResources = [...sharedSearchResources, 'accessoryRanges'];

const searchResourcesArchived = [...sharedSearchResources, 'accessoryRangesArchived'];

const routes = [
	{
		path: '/accessory/detail/:id',
		element: <Detail />,
		permissions: [PERMISSIONS.READACCESSORY],
		resources: basicResources,
	},
	{
		path: '/accessory/search',
		element: <Search archive={false} />,
		permissions: [PERMISSIONS.READACCESSORY],
		resources: searchResources,
	},
	{
		path: '/accessory/new',
		element: <New />,
		permissions: [PERMISSIONS.WRITEACCESSORY],
		resources: basicResources,
	},
	{
		path: '/accessory/archive',
		element: <Search archive={true} />,
		permissions: [PERMISSIONS.WRITEACCESSORY],
		resources: searchResourcesArchived,
	},
	{
		path: '/accessory/copy/:id',
		element: <Detail />,
		permissions: [PERMISSIONS.WRITEACCESSORY],
	},
];

export default [...routes.map(wrapProtectedRoute)];
